module.exports = __webpack_public_path__ + "static/fr-logo100-web-black-15c78d691ecdd52753c93b0196c56d60.svg";